import { createTheme, ThemeProvider } from '@mui/material/styles';

import "@fontsource/raleway"
import "@fontsource/oswald"


/**
 * https://mui.com/material-ui/customization/default-theme/ seems to have the best examples 
 * of how the default theme is put together and how it might be overriden
 * 
 * https://99designs.com/blog/tips/font-pairings/
 * 
 * https://fontsource.org/
 */

export const theme = createTheme({
    typography: {
        fontFamily: 'Raleway',
        h1: {
            fontFamily: "Oswald",
            fontWeight: 700,
        },
        h2: {
            fontFamily: "Oswald",
            fontWeight: 600,
        },
        h3: {
            fontFamily: "Oswald",
            fontWeight: 550,
        },
        h4: {
            fontFamily: "Oswald",
            fontWeight: 500,
        },
        h5: {
            fontFamily: "Oswald",
            fontWeight: 300,
        },
        h6: {
            fontFamily: "Oswald",
            fontWeight: 300,
        },
    }
});

export const themeRobotoGeorgia = createTheme({
    typography: {
        fontFamily: 'Roboto Slab',
        h1: {
            fontFamily: "Georgia"
        },
        h2: {
            fontFamily: "Georgia"
        },

    },
    components: {
        MuiButtonBase: {
            defaultProps: {
                // The props to change the default for.
                disableRipple: true, // No more ripple, on the whole application 💣!
            },
        },
    }
});
